import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from "@angular/common/http";
import { Observable, throwError, pipe, BehaviorSubject } from "rxjs";
import { catchError, tap, filter, take, switchMap } from "rxjs/operators";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private jwtHelper: JwtHelperService,  public router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if(this.router.url.includes('admin')){
      if(this.getToken()){
        if (this.jwtHelper.isTokenExpired(this.getToken())) {
          window.alert("Your session has expired, please log in again");
          this.router.navigateByUrl('onboarding/login');
          return;
         }  
         request = this.addTokenToRequest(request, this.getToken());
      } 
      return next.handle(request).pipe(
        catchError(error => {
          return throwError(error);
        })
      );
    }
    return next.handle(request).pipe(
      catchError(error => {
        return throwError(error);
      })
    );
   
   
  }

  getToken() {
    return JSON.parse(localStorage.getItem("token"));
  }

  addTokenToRequest(req: HttpRequest<any>, token: string) {
    return req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }
 
}
